import { getDataFromState, getStateFromData } from '@components/CommandParameters/helpers'

import { FormCommand, GETCommand } from '@types'

export const transformRedefinitionCommandsFormDataToRequestData = (
  redefinitionCommands: FormCommand[] | null | undefined
) => {
  return redefinitionCommands?.map(command => {
    return {
      ...command,
      name: command.name?.id,
      objectCode: command.sourceCommand?.id,
      objectTitle: command.sourceCommand?.label,
      type: command.type?.id,
      resource: command.sourceType?.id,
      parameters: getDataFromState(command.parameters),
      body: getDataFromState(command.body),
    }
  })
}

export const transformRedefinitionCommandsRequestDataToFormData = (
  redefinitionCommands: GETCommand[] | null | undefined
) => {
  return redefinitionCommands?.map(command => {
    return {
      ...command,
      name: {
        id: command.name,
        label: command.name,
      },
      sourceCommand: {
        id: command?.objectCode,
        label: command?.objectTitle,
      },
      sourceType: {
        id: command?.resource,
        label: command?.resource,
      },
      type: { id: command.type, label: command.type },
      parameters: getStateFromData(command.parameters),
      body: getStateFromData(command.body),
    }
  })
}
